import { styled } from "styled-components"
import { ProjectInfo } from "../ProjectInfo";

const Container = styled.div`
    background: linear-gradient(to right, ${({ theme }) => theme.colors.primary}, #fa7f72);
    padding: 20px;
    border-radius: ${({ theme }) => theme.borderRadius};
`;

const Grade = styled.h3`
    font-weight: 400;
    line-height: 13px;
    font-family: ${({ theme }) => theme.fonts.main};
`;

const Title = styled.h2`
`;

const Text = styled.p`
    margin-bottom: 10px;
`;

export function Card({ grade, title, text, type, tags }) {
    return (
        <Container>
            <Grade>
                {grade}
            </Grade>
            <Title>
                {title}
            </Title>
            <Text>
                {text}
            </Text>
            <ProjectInfo type={type} technologies={tags} />
        </Container>
    )
}